<template>
    <div>
        <div class="container-fluid mt-5 mb-6 mt-lg-6 mb-lg-9">
            <div class="row justify-content-center">
                <div class="col-xl-6 order-xl-1">
                    <card shadow type="secondary" v-if="user">
                        <div slot="header" class="bg-white border-0">
                            <div class="row align-items-center">
                                <div class="col-12">
                                    <h3 class="mb-0">{{ $t('changing_password') }}</h3>
                                </div>
                            </div>
                        </div>
                        <template>
                            <form role="form">
                                <div class="pl-lg-4">
                                    <div class="row" v-if="passwordUser">
                                        <div class="col-lg-12">
                                            <base-alert type="success" dismissible="true">
                                                {{ $t('password_changed') }}.
                                            </base-alert>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-lg-6">
                                            <base-input alternative=""
                                                        :label="$t('old_password')"
                                                        :placeholder="$t('enter_old_password')"
                                                        input-classes="form-control-alternative"
                                                        type="password"
                                                        :error="fieldError('oldPassword')"
                                                        v-model="oldPassword"
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div class="pl-lg-4">
                                    <div class="row">
                                        <div class="col-lg-6">
                                            <base-input alternative=""
                                                        :label="$t('new_password')"
                                                        :placeholder="$t('enter_new_password')"
                                                        input-classes="form-control-alternative"
                                                        type="password"
                                                        :error="fieldError('password')"
                                                        v-model="newPassword"
                                            />
                                        </div>
                                        <div class="col-lg-6">
                                            <base-input alternative=""
                                                        :label="$t('repeat_new_password')"
                                                        :placeholder="$t('enter_repeat_new_password')"
                                                        input-classes="form-control-alternative"
                                                        type="password"
                                                        v-model="newPasswordRepeat"
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div class="pl-lg-4">
                                    <div class="row">
                                        <div class="col-lg-12">
                                            <div class="text-center">
                                                <base-button :disabled="!submitEnabled" type="primary" class="my-4"
                                                             @click="submit">{{ $t('change_password') }}
                                                </base-button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </form>

                        </template>
                    </card>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import {getUser} from "../data/jwt.service";
    import userApi from "../data/UserApi";

    export default {
        name: 'user-password',
        data() {
            return {
                user: null,
                oldPassword: '',
                newPassword: '',
                newPasswordRepeat: '',

                passwordUser: null,

                error: null,
                fieldsErrors: [],
                loading: false,
            }
        },

        computed: {
            submitEnabled() {
                return this.oldPassword && this.oldPassword.length > 0
                    && this.newPassword && this.newPassword.length > 0
                    && this.newPasswordRepeat && this.newPasswordRepeat.length > 0
                    && this.newPasswordRepeat === this.newPassword
            },
        },

        mounted() {
            this.user = getUser()
        },

        methods: {
            submit() {
                this.error = null
                this.fieldsErrors = []
                this.loading = true
                userApi.password(this.oldPassword, this.newPassword)
                    .then(response => {
                        this.passwordUser = response
                        this.loading = false
                        this.oldPassword = ''
                        this.newPassword = ''
                        this.newPasswordRepeat = ''
                        //this.$router.push('/course/1')
                    })
                    .catch(error => {
                        let data = error.response.data
                        if (error.response.status === 422) {
                            this.fieldsErrors = data
                        } else if (error.response.status === 401) {
                            this.error = this.$t('error_invalid_login')
                        } else {
                            this.error = this.pretty(data)
                        }
                        this.loading = false
                    })
            },

            fieldError(fieldName) {
                let errors = []
                if (this.fieldsErrors) {
                    this.fieldsErrors.filter(field => {
                        if (field.field === fieldName) {
                            errors.push(field.message)
                        }
                    })
                }
                if (errors.length > 0)
                    return errors.join(', ')
                return null
            },
            pretty(value) {
                if (value.message) {
                    return value.message
                }
                return JSON.stringify(value, null, 2)
            },
        }
    };
</script>
<style></style>
